import type { CreditBalanceRepository } from '@src/domain/credits/repository/credit-balance.repository';
import type { CreditBalanceDTO } from '../dto/credit-balance.dto';
import { CreditBalanceMapper } from '../mappers/credit-balance.mapper';

export class GetCreditBalanceUseCase {
    constructor(private repository: CreditBalanceRepository) { }

    async execute(): Promise<CreditBalanceDTO> {
        const creditBalance = await this.repository.getCreditBalance();
        return CreditBalanceMapper.toDTO(creditBalance);
    }
}
